import React, {useEffect, useState} from "react";
import SmallCardProject from "../project/overview/SmallCardProject";
import useFilterUser from "../../custom-hooks/useFilterUser";
import styled from "styled-components";
import Checkbox from "../inputs/Checkbox";
import {BlueButton} from "../buttons/ButtonStyles";
import {getDateInFrench} from "../../utils/dateUtils";


const Projects = ({
                      projects,
                      query,
                      multipleSelectionProjectIds,
                      callSbAgainHandler,
                      setMultipleSelectionProjectIds, isChecked, setIsChecked
                  }) => {


    let [projectsList, setProjectsList] = useState([])
    const all = "all"
    const few = "few"

    useEffect(() => {
        setProjectsList(projects)
    }, [projects])

    const {
        getFullNameInverseNoWhiteSpace,
        getFullNameNoWhiteSpace,
        getQueryNoWhiteSpace
    } = useFilterUser(projectsList)


    const getClassName = (project_id) => {
        if (multipleSelectionProjectIds.includes(project_id)) {
            return "green-border-full"
        } else {
            return ''
        }
    }

    const selectProjects = (e, state) => {
        let isChecked = e.target.checked
        const element = parseInt(e.target.value)
        if (isChecked) {
            if (state === all) {
                setMultipleSelectionProjectIds(projects.map(p => p.id))
            }
            if (state === few) {
                setMultipleSelectionProjectIds(oldArray => [...oldArray, element]);
            }
        } else {
            if (state === all) {
                setMultipleSelectionProjectIds([])
            }
            if (state === few) {
                let newArray = multipleSelectionProjectIds.filter(p => p !== element)
                setMultipleSelectionProjectIds(newArray)
            }
        }
        if (state === few) {
            getClassName(element)
        }
        if (state === all) {
            setIsChecked(e.target.checked)
        }
    }
    return (
        <>
            <Wrapper>
                <Checkbox
                    title={"Sélectionner tous les projets"}
                    value={0}
                    handleChange={(e) => selectProjects(e, all)}
                    checked={isChecked}
                />
                <h2> Nombre de projets : {projects.length}</h2>
                <Container>
                    {projectsList.length === 0 &&
                    <h2> Pas de projet avec cette sélection </h2>
                    }
                    {projectsList
                        .filter(p =>
                            p.pilot.firstName.toLowerCase().includes(query.toLowerCase()) ||
                            p.pilot.lastName.toLowerCase().includes(query.toLowerCase()) ||
                            p.name.toLowerCase().includes(query.toLowerCase()) ||
                            getFullNameNoWhiteSpace(p.pilot).includes(getQueryNoWhiteSpace(query)) ||
                            getFullNameInverseNoWhiteSpace(p.pilot).includes(getQueryNoWhiteSpace(query))
                        )

                        .map(p => (
                            <ContainerProjectsInfo className={getClassName(p.id)} key={p.id + "/" + p.name}>
                                <div id={"dashboard-check-div"}>
                                    <Checkbox
                                        title={"Sélectionner ce projet"}
                                        id={p.id}
                                        value={p.id}
                                        handleChange={(e) => selectProjects(e, few)}
                                        checked={multipleSelectionProjectIds.includes(p.id)}
                                    />
                                </div>
                                <SmallCardProject
                                    name={p.name}
                                    pilot={p.pilot}
                                    weather={p.weather}
                                    advancement={p.advancement}
                                    projectId={p.id}
                                    endDate={p.endDate}
                                    tags={p.tags}
                                    lastUpdate={p.lastUpdate}
                                    startDate={p.startDate}
                                    confidential={p.confidential}
                                />
                                <UpdateSection>
                                    <p> Dernière relance
                                        : {p.lastReminder === null ? "projet jamais relancé" : getDateInFrench(p.lastReminder)}</p>
                                    <Button onClick={() => callSbAgainHandler(p.id)}>
                                        <h6> Relancer </h6>
                                    </Button>
                                </UpdateSection>
                            </ContainerProjectsInfo>
                        ))}
                </Container>
            </Wrapper>

        </>
    )
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1rem;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  gap: 2rem;
`
const ContainerProjectsInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem;

  #dashboard-check-div {
    display: flex;
    width: 100%;
    align-items: baseline;
    justify-content: flex-start;

    p {
      font-size: 80%;
    }
  }

  .checkbox-wrapper {
    align-self: flex-start;
  }

  @media (min-width: 768px) {
    width: 23rem;
    
  }
`
const UpdateSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1em;
  justify-content: space-between;
  width: 100%;

  p {
    background-color: var(--color-purple-01);
    padding: 0.5em;
    border-radius: 10px;
    font-size: 0.7rem;
    flex-grow: 0.7;
  }
`
const Button = styled(BlueButton)`
  border-radius: 10px;
  padding: 0.5em;
  flex-grow: 0.3;

  h6 {
    font-size: 0.8rem;
    line-height: initial;
    text-align: center;
    flex-grow: 1;
  }
`

export default Projects;